export default {
   // apiser: "https://www.fajiangyu.net",
   apiser: "https://www.trustcute.net",
   // apiser: "http://localhost:9090",
   // apiser: "http://localhost:9091",
   // apiser: "http://172.28.6.107:6991",
}
